<nz-modal
    [(nzVisible)]="isVisible"
    [nzTitle]="modalTitle"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="save()"
    [nzOkLoading]="isConfirmLoading"
    
    [nzCancelDisabled]="isConfirmLoading"
    [nzMaskClosable]="!isConfirmLoading"
    [nzKeyboard]="!isConfirmLoading"
    [nzClosable]="!isConfirmLoading"

    nzOkText="Save"
    nzCancelText="Cancel"
    [nzWidth]="600">

    <ng-template #modalTitle>
        Reset Password: {{ user?.username }}
    </ng-template>

    <ng-container *nzModalContent>
        
        <nz-alert
            nzType="warning"
            nzShowIcon
            [nzMessage]="'Are you sure you wish to reset password for ' + user?.name + ' ' + user?.surname + '?'"
            [nzDescription]="'Doing so will result in their old password being unusable.'"
            style="margin-bottom: 24px;">
        </nz-alert>

        @if (serverErrors.length > 0) {
            <nz-alert
                nzType="error"
                nzShowIcon
                nzTitle="Password Policy Validation Failed"
                [nzDescription]="errorListTpl"
                style="margin-bottom: 24px;">
            </nz-alert>
            <ng-template #errorListTpl>
                <ul style="margin: 0; padding-left: 20px;">
                    @for (error of serverErrors; track error) {
                        <li>{{ error }}</li>
                    }
                </ul>
            </ng-template>
        }

        <form nz-form [formGroup]="form" [nzLayout]="'horizontal'">
            
            <nz-form-item>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzRequired>New Password</nz-form-label>
                <nz-form-control [nzSm]="16" [nzXs]="24" [nzErrorTip]="passwordErrorTpl">
                    <input nz-input type="password" formControlName="newPassword" placeholder="New Password" />
                    <ng-template #passwordErrorTpl>
                        @if (form.get('newPassword')?.errors?.['required']) {
                            Password is required
                        }
                    </ng-template>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSm]="8" [nzXs]="24" nzRequired>Confirm Password</nz-form-label>
                <nz-form-control [nzSm]="16" [nzXs]="24" 
                    [nzValidateStatus]="confirmPasswordStatus"
                    [nzErrorTip]="confirmErrorTpl">
                    
                    <input nz-input type="password" formControlName="confirmPassword" placeholder="Confirm Password" />
                    
                    <ng-template #confirmErrorTpl>
                        @if (form.get('confirmPassword')?.errors?.['required']) {
                            Confirm Password is required
                        } @else if (form.hasError('passwordMismatch')) {
                            Passwords do not match
                        }
                    </ng-template>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-control [nzSm]="16" [nzXs]="24" [nzOffset]="8">
                    <label nz-checkbox formControlName="forceReset">
                        Force user to reset password on login
                    </label>
                </nz-form-control>
            </nz-form-item>

        </form>
    </ng-container>

</nz-modal>